import React, { Fragment, PureComponent } from 'react';
// Data
import storeConnect from 'data/store-connect';
import authStore, { signOut } from 'data/auth';
// Components
import ImageAvatar from 'ui/image/image-avatar';
import Popover from 'ui/popover';
import Button from 'ui/button';

interface ProfileProps {
  email: string;
  photoUrl: string;
}
@storeConnect(
  {
    email: () => authStore.email,
    photoUrl: () => authStore.photoUrl
  },
  [authStore]
)
class Profile extends PureComponent<ProfileProps> {
  state = {
    open: false
  };

  handleOpen = (e: MouseEvent) => {
    this.setState({ open: true, anchorEl: e.currentTarget });
  };

  handleClose = () => {
    this.setState({ open: false });
  };
  render() {
    const { email, photoUrl } = this.props;
    const { open, anchorEl } = this.state;
    return (
      <Fragment>
        <ImageAvatar small image={photoUrl} onClick={this.handleOpen} />
        <Popover
          anchorOrigin={['right', 'bottom']}
          targetOrigin={['right', 'top']}
          open={open}
          anchorEl={anchorEl}
          className="padding column"
          onRequestClose={this.handleClose}
        >
          <h4>{email}</h4>
          <Button flat="Sign out" onClick={signOut} />
        </Popover>
      </Fragment>
    );
  }
}
export default Profile;
